import { get } from 'lodash'
import reduceWithSeparator from '@/helpers/reduce-with-separator'

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório médico',
  emergency_room: 'Emergência',
  laboratory: 'Labotarório',
  others: 'Outros'
}

const parseType = (type) => {
  return get(types, type, 'Outros')
}

export default {
  typeClinic () {
    return parseType(this.profile.company_type)
  },
  getSpecialities () {
    return reduceWithSeparator(this.profile.specialities, 'name')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/resources/computed.js